// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CoordinatesInput-container-g_76A {
  width: 100%;
  margin: 20px 0;
}

.CoordinatesInput-inputGroup-C0h6p {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 10px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.CoordinatesInput-input-FHC6D {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  min-width: 300px;
  padding: 12px 16px;
  font-size: 16px;
  border: 2px solid #ddd;
  border-radius: 8px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.CoordinatesInput-input-FHC6D:focus {
  outline: none;
  border-color: #007bff;
  -webkit-box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
          box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.CoordinatesInput-inputValid-qHg9A {
  border-color: #28a745 !important;
}

.CoordinatesInput-inputValid-qHg9A:focus {
  -webkit-box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1) !important;
          box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1) !important;
}

.CoordinatesInput-inputError-JbrBa {
  border-color: #dc3545 !important;
}

.CoordinatesInput-inputError-JbrBa:focus {
  -webkit-box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1) !important;
          box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1) !important;
}

.CoordinatesInput-testButton-lzUlv {
  padding: 12px 24px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  -webkit-transition: background-color 0.3s ease;
  transition: background-color 0.3s ease;
  white-space: nowrap;
}

.CoordinatesInput-testButton-lzUlv:hover {
  background-color: #0056b3;
}

.CoordinatesInput-feedback-FpJPK {
  margin-top: 10px;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
}

.CoordinatesInput-feedbackSuccess-kv_BZ {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.CoordinatesInput-feedbackError-E6rgn {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.CoordinatesInput-helpText-PzYeI {
  margin-top: 10px;
  font-size: 14px;
  color: #6c757d;
  font-style: italic;
}

/* Responsive */

@media (max-width: 768px) {
  .CoordinatesInput-inputGroup-C0h6p {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .CoordinatesInput-input-FHC6D {
    min-width: 100%;
  }

  .CoordinatesInput-testButton-lzUlv {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CoordinatesInput/CoordinatesInput.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,oDAA4C;UAA5C,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+DAAuD;UAAvD,uDAAuD;AACzD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+DAAuD;UAAvD,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8CAAsC;EAAtC,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,eAAe;;AACf;EACE;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".container {\n  width: 100%;\n  margin: 20px 0;\n}\n\n.inputGroup {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.input {\n  flex: 1;\n  min-width: 300px;\n  padding: 12px 16px;\n  font-size: 16px;\n  border: 2px solid #ddd;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.inputValid {\n  border-color: #28a745 !important;\n}\n\n.inputValid:focus {\n  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1) !important;\n}\n\n.inputError {\n  border-color: #dc3545 !important;\n}\n\n.inputError:focus {\n  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1) !important;\n}\n\n.testButton {\n  padding: 12px 24px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  white-space: nowrap;\n}\n\n.testButton:hover {\n  background-color: #0056b3;\n}\n\n.feedback {\n  margin-top: 10px;\n  padding: 12px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.feedbackSuccess {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.feedbackError {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.helpText {\n  margin-top: 10px;\n  font-size: 14px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .inputGroup {\n    flex-direction: column;\n  }\n\n  .input {\n    min-width: 100%;\n  }\n\n  .testButton {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CoordinatesInput-container-g_76A`,
	"inputGroup": `CoordinatesInput-inputGroup-C0h6p`,
	"input": `CoordinatesInput-input-FHC6D`,
	"inputValid": `CoordinatesInput-inputValid-qHg9A`,
	"inputError": `CoordinatesInput-inputError-JbrBa`,
	"testButton": `CoordinatesInput-testButton-lzUlv`,
	"feedback": `CoordinatesInput-feedback-FpJPK`,
	"feedbackSuccess": `CoordinatesInput-feedbackSuccess-kv_BZ`,
	"feedbackError": `CoordinatesInput-feedbackError-E6rgn`,
	"helpText": `CoordinatesInput-helpText-PzYeI`
};
module.exports = ___CSS_LOADER_EXPORT___;
